<template>
  <DefaultLayout>
    <div class="page-header">
      <h1>Dashboard de Pagos</h1>
      <p class="subtitle">Resumen de suscripciones y transacciones</p>
    </div>

    <div class="stats-grid">
      <Card v-for="stat in stats" :key="stat.label">
        <template #content>
          <div class="stat-item">
            <i :class="['pi', stat.icon, 'stat-icon']" />
            <div>
              <div class="stat-value">{{ stat.value }}</div>
              <div class="stat-label">{{ stat.label }}</div>
            </div>
          </div>
        </template>
      </Card>
    </div>

    <Card class="mt-4">
      <template #title>Tenants con suscripción activa</template>
      <template #content>
        <DataTable :value="activeTenants" :loading="loading" responsiveLayout="scroll">
          <Column field="name" header="Tenant" />
          <Column field="email" header="Email" />
          <Column field="subscription_status" header="Estado">
            <template #body="{ data }">
              <Tag :severity="statusSeverity(data.subscription_status)" :value="data.subscription_status" />
            </template>
          </Column>
          <Column field="plan_id" header="Plan ID" />
        </DataTable>
      </template>
    </Card>
  </DefaultLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import DefaultLayout from '../../components/layout/DefaultLayout.vue';
import Card from 'primevue/card';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tag from 'primevue/tag';
import { tenantsService } from '../../services/tenants';

const loading = ref(false);
const activeTenants = ref([]);
const stats = ref([
  { label: 'Tenants activos', value: '—', icon: 'pi-users' },
  { label: 'Ingresos del mes', value: '—', icon: 'pi-dollar' },
  { label: 'Pagos pendientes', value: '—', icon: 'pi-clock' },
]);

const statusSeverity = (status) => {
  const map = { active: 'success', past_due: 'warning', suspended: 'danger', inactive: 'secondary' };
  return map[status] || 'info';
};

onMounted(async () => {
  loading.value = true;
  try {
    const tenants = await tenantsService.getTenants();
    activeTenants.value = tenants;
    stats.value[0].value = tenants.filter(t => t.subscription_status === 'active').length;
  } catch (e) {
    console.error(e);
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
.page-header { margin-bottom: 1.5rem; }
.page-header h1 { margin-bottom: 0.25rem; color: #1e293b; }
.subtitle { color: #6b7280; }
.stats-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; }
.stat-item { display: flex; align-items: center; gap: 1rem; }
.stat-icon { font-size: 2rem; color: #6366f1; }
.stat-value { font-size: 1.5rem; font-weight: 700; color: #1e293b; }
.stat-label { color: #6b7280; font-size: 0.875rem; }
.mt-4 { margin-top: 1.5rem; }
</style>
